import { flowRight, attempt } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { reduxForm, startSubmit } from 'redux-form';

import { showMessage } from '../../actions/show-message';
import getEmptyFields from '../../services/get-empty-fields';
import postFormSettings from '../../services/post-form-settings';
import commentFormSettings from '../../services/comment-form-settings';
import messages, { REQUIRE_POST_FIELDS } from '../../components/message/messages';
import withEnvironment from '../../hoc/with-environment';

export class PublishButton extends Component {
  handleClick = () => {
    const { submit, invalid, formName, onSuccess } = this.props;
    if (!invalid) {
      submit(formName);
      attempt(onSuccess);
    }

    const { showMessage, errors } = this.props;
    const emptyFields = getEmptyFields(errors);

    if (emptyFields.length) {
      showMessage(messages[REQUIRE_POST_FIELDS].content(emptyFields), messages[REQUIRE_POST_FIELDS].type);
    }
  };

  render = () => {
    const { children } = this.props;
    return React.cloneElement(React.Children.only(children), {
      onClick: this.handleClick,
    });
  };
}

PublishButton.propTypes = {
  onSuccess: PropTypes.func,
  invalid: PropTypes.bool,
  submit: PropTypes.func,
  showMessage: PropTypes.func,
  errors: PropTypes.object,
  formName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const mapDispatchToProps = {
  submit: startSubmit,
  showMessage,
};

export const PostPublishButton = flowRight(
  reduxForm(postFormSettings, () => ({ formName: 'post' }), mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' }),
)(PublishButton);

export const CommentPublishButton = flowRight(
  reduxForm(commentFormSettings, () => ({ formName: 'comment' }), mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' }),
)(PublishButton);
